<template>
  <BittsContainer class="api-key-usage-tile">
    <span class="api-key-usage-tile__label">{{ label }}</span>
    <p class="api-key-usage-tile__value">
      {{ value }}
      <span class="api-key-usage-tile__unit">{{ unit }}</span>
    </p>
    <BittsProgressBar
      v-if="progress"
      :width="`${progress.percent}%`"
      :color="progress.color"
      class="api-key-usage-tile__bar"
    />
    <span class="api-key-usage-tile__footnote">{{ footnote }}</span>
  </BittsContainer>
</template>

<script setup lang="ts">
import { BittsContainer, BittsProgressBar } from '@crossbeam/bitts';

import type { UsageColor } from '@/utils/usageColor';

defineProps<{
  label: string;
  value: string;
  unit: string;
  footnote: string;
  progress?: { percent: number; color: UsageColor };
}>();
</script>

<style scoped lang="pcss">
@reference "../../../css/theme.css";

.api-key-usage-tile {
  @apply flex flex-col;
}

.api-key-usage-tile__label {
  @apply text-base text-neutral-text;
}

.api-key-usage-tile__value {
  @apply text-xl font-bold text-neutral-text-strong m-0 mt-8;
}

.api-key-usage-tile__unit {
  @apply text-base font-normal text-neutral-text-weak;
}

.api-key-usage-tile__bar {
  @apply my-8;
}

.api-key-usage-tile__footnote {
  @apply text-sm text-neutral-text-weak mt-auto pt-8;
}
</style>
